/// <reference types="vite/client" />
import { Authenticator } from '@aws-amplify/ui-react';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import * as Sentry from '@sentry/react';
import React from 'react';
import ReactDOM from 'react-dom/client';
import * as TagManager from 'react-gtm-module';
import { QueryClient, QueryClientProvider } from 'react-query';
import { HashRouter, Routes } from 'react-router-dom';
import { RecoilRoot } from 'recoil';
import RecoilNexus from 'recoil-nexus';
import App from './App';
import { CodeMasterProvider } from '@/components/shared/CodeMasterProvider';
import { initSentry } from '@/modules/utils/sentry';
import 'dayjs/locale/ja';
import '@/assets/styles/main.css';

const tagManagerArgs = {
  gtmId: import.meta.env.VITE_GTM_ID,
};

TagManager.initialize(tagManagerArgs);

const queryClient = new QueryClient();

initSentry();
/**
 * SentryでラップされたReact RouterのRoutesコンポーネント。
 *
 * @remarks
 * このコンポーネントは`initSentry`の後に初期化される必要があります。
 * インポートしているファイルで初期化すると、実行順の関係で`initSentry`より先に
 * 初期化されてしまうため、ここで初期化を行っています。
 */
const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Root element not found');
ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <LocalizationProvider dateAdapter={AdapterDayjs} adapterLocale="ja">
      <Authenticator.Provider>
        <RecoilRoot>
          <RecoilNexus />
          <QueryClientProvider client={queryClient}>
            <CodeMasterProvider>
              <HashRouter>
                <App RoutesComponent={SentryRoutes} />
              </HashRouter>
            </CodeMasterProvider>
          </QueryClientProvider>
        </RecoilRoot>
      </Authenticator.Provider>
    </LocalizationProvider>
  </React.StrictMode>,
);
